import React from 'react';

import PropTypes from 'prop-types';
import { IconButton } from '@telus-uds/components-web';

import {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalCancel,
  ModalHeading
} from './css';

const ConfirmationBox = ({
  open = false,
  hideCloseButton = false,
  setOpen,
  header = '',
  children,
  onClose = () => {}
}) => {
  const handleModalClose = () => {
    setOpen();
    onClose();
  };
  return (
    open && (
      <Backdrop>
        <ModalMain>
          <ModalInner>
            <ModalMessageMain>
              {header && <ModalHeading>{header}</ModalHeading>}
              {children}
            </ModalMessageMain>
            {!hideCloseButton && (
              <ModalCancel>
                <IconButton
                  action="close"
                  onPress={handleModalClose}
                  accessibilityLabel="Close"
                />
              </ModalCancel>
            )}
          </ModalInner>
        </ModalMain>
      </Backdrop>
    )
  );
};

ConfirmationBox.propTypes = {
  open: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func
};

export default ConfirmationBox;
